export default {
    methods: {
        validate(el) {
            el = el || this;
            if (el.$children && el.$children.length) {
                let invalidChildren = el.$children.map(c => this.validate(c)).some(c => !c)
                if (invalidChildren) return false;
            }
            let isValid = el.$valid !== false;
            isValid || (el.$showValidation && el.$showValidation());
            return isValid;
        },
        $resetValidation(el) {
            el = el || this;
            
            el.$children.map(c => this.$resetValidation(c));
            
            el.resetValidation && el.resetValidation();
        }
    }
};